import { useEffect, useState } from "react";
import { Flex, message, Result, Spin, Typography } from "antd";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { ROUTES } from "../../../constant/routes";
import { useDispatch } from "react-redux";
import { magicSigninThunk } from "../../../store/user/thunks";
import { parseError } from "../../../utils/shared";

const { Title, Text } = Typography;

const MagicLink = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState("loading");

  const dispatch = useDispatch();

  useEffect(() => {
    const verifyMagicLink = async () => {
      try {
        const token = searchParams.get("token");

        if (!token) {
          setStatus("error");
          setLoading(false);
          return;
        }

        const { payload } = await dispatch(
          magicSigninThunk({
            token,
          }),
        );

        if (payload?.id) {
          message.success("Login successful!");
          navigate(ROUTES.CHATS);
          setStatus("success");
        } else setStatus("error");
      } catch (error) {
        parseError(error, true);
        setStatus("error");
      } finally {
        setLoading(false);
      }
    };

    verifyMagicLink();
  }, [navigate, searchParams]);

  return (
    <div className="auth-right">
      {loading ? (
        <Flex
          vertical
          align="center"
          justify="center"
          gap={16}
          style={{ padding: 32 }}
        >
          <Spin size="large" />
          <Title level={4}>Signing you in...</Title>
          <Text type="secondary">
            Signing you in securely. This will only take a moment.
          </Text>
        </Flex>
      ) : status === "success" ? (
        <Result
          status="success"
          title="Successfully Signed In"
          subTitle="Redirecting you to your dashboard..."
        />
      ) : (
        <Result
          status="error"
          title="Sign-in Link Expired"
          subTitle="Your sign-in link is no longer valid. Please request a new one."
          extra={<Link to={ROUTES.SIGNIN}>Get a new sign-in link</Link>}
        />
      )}
    </div>
  );
};

export default MagicLink;
